import { useQuery } from "@tanstack/react-query";
import ticketsService from "services/admin/ticketsService";
import { ComplaintsStatsResponse } from "interfaces/entities/ticketStats";

export const useComplaintsStats = (year?: number, branchID?: number | string) => {
    return useQuery<ComplaintsStatsResponse>({
        queryKey: ["complaints-stats", year ?? null, branchID ?? null],
        queryFn: async () => {
            const response = await ticketsService.getComplaintsStats(year, branchID);
            return response.data;
        },
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};
